import { UILoadingRingController } from '../ui_loading_ring/UILoadingRingController.ts';
import { TimeUtils } from '../../../../../shared/utils/TimeUtils.ts';
import { uiManagerEvents } from '../../EntryShared.ts';
import { setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UILobbyTableHeaderController {
    showActiveTableBody() {
        this.uiLoadingRingController.hideLoading();
        this.setRefreshIconsRotating(false);
        if (this.roomsTabDiv.classList.contains(this.ACTIVE_TAB_CLASS)) this.roomsTableBody.style.display = '';
        if (this.spectateTabDiv.classList.contains(this.ACTIVE_TAB_CLASS)) this.spectateTableBody.style.display = '';
    }
    updateLastRefreshTimestamp() {
        this.lastRefreshTimestamp = Date.now();
    }
    isRoomListActive() {
        return this.roomsTable.style.display != 'none';
    }
    openSpectateTab() {
        this.clickedRefreshSpectate();
        this.onTabChange();
    }
    setRefreshIconsRotating(rotating) {
        const rotationClass = 'rotate';
        if (rotating) {
            this.roomsIcon.classList.add(rotationClass);
            this.spectateIcon.classList.add(rotationClass);
        } else {
            this.roomsIcon.classList.remove(rotationClass);
            this.spectateIcon.classList.remove(rotationClass);
        }
    }
    tableHeaderActions() {
        setElementOnClick(this.roomsTabDiv, ()=>{
            this.clickedRooms();
            this.onTabChange();
        });
        setElementOnClick(this.spectateTabDiv, ()=>this.openSpectateTab());
        setElementOnClick(this.spectateIcon, ()=>this.clickedRefreshSpectate());
    }
    refreshIfLastRefreshTimestampPassed() {
        const currentTime = new Date().getTime();
        const timePassed = currentTime - this.lastRefreshTimestamp;
        const refreshTimeSpectate = TimeUtils.MILLISECONDS * 30;
        if (timePassed >= refreshTimeSpectate && this.spectateTabDiv.classList.contains(this.ACTIVE_TAB_CLASS)) {
            this.refreshSpectate();
        }
    }
    initAutoRefresh() {
        setInterval(()=>{
            if (!uiManagerEvents.isSceneLobby()) return;
            if (!this.isTabInFocus) return;
            this.refreshIfLastRefreshTimestampPassed();
        }, TimeUtils.MILLISECONDS);
        // When the user switches away from the tab
        window.addEventListener('blur', ()=>{
            this.isTabInFocus = false;
        });
        // When the user switches back to the tab
        window.addEventListener('focus', ()=>{
            this.isTabInFocus = true;
            this.refreshIfLastRefreshTimestampPassed();
        });
    }
    clickedRefreshSpectate() {
        AudioManager.play(AudioType.Click);
        this.refreshSpectate();
    }
    clickedRooms() {
        AudioManager.play(AudioType.Click);
        this.selectRooms();
    }
    refreshSpectate() {
        this.roomsIcon.style.display = 'inline';
        this.setRefreshIconsRotating(true);
        this.roomsTabDiv.classList.remove(this.ACTIVE_TAB_CLASS);
        this.spectateTabDiv.classList.add(this.ACTIVE_TAB_CLASS);
        if (this.roomsTable.style.display != 'none') this.roomsTable.style.display = 'none';
        if (this.spectateTable.style.display != 'table') this.spectateTable.style.display = 'table';
        void this.refreshGameList();
    }
    selectRooms() {
        this.roomsIcon.style.display = 'none';
        this.roomsTabDiv.classList.add(this.ACTIVE_TAB_CLASS);
        this.spectateTabDiv.classList.remove(this.ACTIVE_TAB_CLASS);
        if (this.spectateTable.style.display != 'none') this.spectateTable.style.display = 'none';
        if (this.roomsTable.style.display != 'table') this.roomsTable.style.display = 'table';
    }
    constructor(refreshGameList, onTabChange){
        this.ACTIVE_TAB_CLASS = 'scene_lobby_mid_tabs_active';
        this.isTabInFocus = true;
        this.roomsTabDiv = document.getElementById('lobby_center_table_rooms_tab_div');
        this.spectateTabDiv = document.getElementById('lobby_center_table_spectate_tab_div');
        this.roomsIcon = document.getElementById('lobby_center_table_rooms_refresh_icon_rooms_table');
        this.roomsIcon.style.display = 'none';
        this.spectateIcon = document.getElementById('lobby_center_table_rooms_refresh_icon_spectate_table');
        this.roomsTable = document.getElementById('lobby_center_rooms_table');
        this.spectateTable = document.getElementById('lobby_center_spectate_table');
        this.roomsTableBody = document.getElementById('lobby_center_rooms_table_body');
        this.spectateTableBody = document.getElementById('lobby_center_spectate_table_body');
        this.uiLoadingRingController = new UILoadingRingController('lobby_center_');
        this.uiLoadingRingController.hideLoading();
        this.tableHeaderActions();
        this.lastRefreshTimestamp = Date.now();
        this.initAutoRefresh();
        this.refreshGameList = refreshGameList;
        this.onTabChange = onTabChange;
    }
}
